import type { ColumnClassification } from './types';
import { parseNumber } from './parseNumber';

// Column type classifier. Ported from CPAiSuite Universal (Tech Spec §6.6 /
// Functional Spec §4.4). Drives Step 2 auto-detection.

// ENG-378 (pass 2): rate and hours are supporting data, not dollar cost fields, so
// their header terms are folded into SKIP_RE and excluded from numeric detection
// entirely (the former standalone `rate`/`hours` classifications are gone).
const SKIP_RE =
	/skip|ignore|exclude|notes?|comment|description|dept|department|code|id$|ssn|tin|\brate\b|per\s*hour|\/hr|\bhrs?\b|\bhours?\b/i;

// ENG-378 (pass 2): date-shaped values (e.g. 4/15/2026, 2026-04-15, 04/15/26) must
// not count toward numeric — parseNumber would otherwise parse them. Signed values
// (-100.00) and accounting negatives ((100.00)) do not match this and are unaffected.
const DATE_RE = /^\d{1,4}[/-]\d{1,2}([/-]\d{2,4})?$/;

export function classifyWideColumn(
	header: string,
	sampleValues: string[]
): ColumnClassification {
	const h = String(header ?? '');

	if (SKIP_RE.test(h)) return 'skip';

	const nonEmpty = sampleValues
		.map((v) => String(v ?? '').trim())
		.filter((v) => v !== '');
	if (nonEmpty.length === 0) return 'text';

	const numeric = nonEmpty.filter(
		(v) => !DATE_RE.test(v.trim()) && Number.isFinite(parseNumber(v))
	).length;
	if (numeric / nonEmpty.length >= 0.5) return 'numeric';

	return 'text';
}
